import {  FromObservable  } from './FromObservable';

export const from = FromObservable.create;


// WEBPACK FOOTER //
// ../../../../node_modules/src/observable/from.ts